// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card-title {
  --color: white;
}

ion-card {
  --background: var(--dark-blue-bg);
  --color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/customer-and-address-card/customer-and-address-card.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,iCAAA;EACA,cAAA;AACJ","sourcesContent":["ion-card-title {\r\n    --color: white;\r\n}\r\n\r\nion-card {\r\n    --background: var(--dark-blue-bg);\r\n    --color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
